import React, { useState } from "react";
import { useIntl } from "react-intl";
import { onToastError, onToastSuccess } from "../../helpers/utils";
import { useNewsLetter } from "../../redux/hooks/hooks";

const Newsletter = () => {
  const data = useNewsLetter();
  const intl = useIntl();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [email, setEmail] = useState("");

  const isValidEmail = () => {
    if (email === "") {
      onToastError(intl.formatMessage({ id: "email.required" }));
      return false;
    }
    if (!emailRegex.test(email)) {
      onToastError(intl.formatMessage({ id: "email.invalid" }));
      return false;
    }
    return true;
  };

  const onSubscribe = () => {
    if (isValidEmail()) {
      onToastSuccess(intl.formatMessage({ id: "subscribed" }));
      setEmail("");
    }
  };

  return (
<div className="bg-[#0a1628] flex flex-col gap-6 py-12 px-6">
      <div className="flex flex-col justify-center items-center text-white text-center">
        <h3 className="font-bold text-2xl mb-2 font-noedisplay">{data?.title}</h3>
        <p className="text-slate-300 font-arial">
          {data?.subtitle || intl.formatMessage({ id: "newsletter.subtitleFallback" })}
        </p>
      </div>
      <div className="flex flex-col gap-4 max-w-md mx-auto w-full">
        <input
          type="email"
          className="text-base rounded-lg px-4 py-3 border-0 focus:outline-none focus:ring-2 focus:ring-[#16A34A] focus:ring-opacity-50 text-gray-800"
          id="email"
          placeholder={data?.input || intl.formatMessage({ id: "email" })}
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className="bg-[#16A34A] rounded-lg border-0 py-3 text-white font-medium text-base hover:bg-[#15803D] transition-colors duration-300"
          onClick={() => onSubscribe()}
        >
          {data?.button || intl.formatMessage({ id: "subscribe" })}
        </button>
      </div>
    </div>
  );
};

export default Newsletter;
